module.exports = __webpack_public_path__ + "static/media/RIFA.05b75afa.jpg";